import Description from 'components/Description/Description';
import Explain from 'components/Explain/Explain';
import Gallery from 'components/Gallery/Gallery';
import HomeVideo from 'components/HomeVideo/HomeVideo';
import NewsSection from 'components/NewsSection/NewsSection';
import SocialSection from 'components/SocialSection/SocialSection';
import SplashImage from 'components/SplashImage/SplashImage';
import SponsorSection from 'components/SponsorSection/SponsorSection';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import withHomePageQuery, { INewsItemResult, WithHomePageQueryProps } from 'enhancers/withHomePageQuery';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import styled from 'styled-components';
import { getTextColor } from 'utils/colors';

type Props = WithHomePageQueryProps & WithLanguageProps & IWithCountryProps;

export const HomePage: React.SFC<Props> = props => {
  const explainBackground =
    !props.loading &&
    props.data &&
    props.data.fetch.Common.Numbers &&
    props.data.fetch.Common.Numbers.BackgroundColor
      ? props.data.fetch.Common.Numbers.BackgroundColor
      : '#ffffff';
  const explainTextColor = getTextColor(explainBackground);

  const socialBackground =
    !props.loading &&
    props.data &&
    props.data.fetch.Common.SocialFeed &&
    props.data.fetch.Common.SocialFeed.BackgroundColor
      ? props.data.fetch.Common.SocialFeed.BackgroundColor
      : '#ffffff';

  const videoBackground =
    !props.loading && props.data && props.data.fetch.Common.Video
      ? props.data.fetch.Common.Video.BackgroundImage
        ? `url(${props.data.fetch.Common.Video.BackgroundImage.src})`
        : '#ffffff'
      : '#ffffff';
  // const videoBackground = '#eee';

  const newsBackground =
    !props.loading &&
    props.data &&
    props.data.fetch.Common.News &&
    props.data.fetch.Common.News.BackgroundColor
      ? props.data.fetch.Common.News.BackgroundColor
      : '#ffffff';

  const newsColor = getTextColor(newsBackground);

  const mapItem = (item: INewsItemResult) => ({
    author: props.getText(item.Author),
    content: props.getText(item.Content),
    featured: item.Featured,
    id: item._meta.id,
    image: item.NewsItemImage ? item.NewsItemImage.src : '',
    title: props.getText(item.Title)
  });

  const sponsorsBackground =
    !props.loading &&
    props.data &&
    props.data.fetch.Common.Logos &&
    props.data.fetch.Common.Logos.BackgroundColor
      ? props.data.fetch.Common.Logos.BackgroundColor
      : '#ffffff';

  return (
    <div>
      <SplashImage
        showGlobalRegistration={
          (!props.loading &&
            props.data &&
            props.country === 'global' &&
            props.data.fetch.Common.Registration &&
            props.data.fetch.Common.Registration.Active === 'yes') ||
          (!props.loading &&
            props.data &&
            props.data.fetch.Country.RegistrationPage &&
            props.data.fetch.Country.RegistrationPage
              .ShowSplashRegistrationButton === 'yes') ||
          false
        }
        text={{
          ButtonLink:
            !props.loading &&
            props.data &&
            props.data.fetch.Country.HomePage &&
            props.data.fetch.Country.HomePage.SplashSection &&
            props.data.fetch.Country.HomePage.SplashSection.SplashButtonLink
              ? props.data.fetch.Country.HomePage.SplashSection.SplashButtonLink
              : null,
          ButtonText:
            !props.loading &&
            props.data &&
            props.data.fetch.Country.HomePage &&
            props.data.fetch.Country.HomePage.SplashSection &&
            props.data.fetch.Country.HomePage.SplashSection.ButtonText
              ? props.data.fetch.Country.HomePage.SplashSection.ButtonText
              : 'Enter your team',
          CountdownText:
            !props.loading &&
            props.data &&
            props.data.fetch.Country.HomePage &&
            props.data.fetch.Country.HomePage.SplashSection &&
            props.data.fetch.Country.HomePage.SplashSection.Countdown &&
            props.data.fetch.Country.HomePage.SplashSection.Countdown
              .CountdownText
              ? props.getText(
                  props.data.fetch.Country.HomePage.SplashSection.Countdown
                    .CountdownText
                )
              : 'to our next event',
          DaysText:
            !props.loading &&
            props.data &&
            props.data.fetch.Country.HomePage &&
            props.data.fetch.Country.HomePage.SplashSection &&
            props.data.fetch.Country.HomePage.SplashSection.Countdown &&
            props.data.fetch.Country.HomePage.SplashSection.Countdown.DaysText
              ? props.getText(
                  props.data.fetch.Country.HomePage.SplashSection.Countdown
                    .DaysText
                )
              : 'Days',
          HoursText:
            !props.loading &&
            props.data &&
            props.data.fetch.Country.HomePage &&
            props.data.fetch.Country.HomePage.SplashSection &&
            props.data.fetch.Country.HomePage.SplashSection.Countdown &&
            props.data.fetch.Country.HomePage.SplashSection.Countdown.HoursText
              ? props.getText(
                  props.data.fetch.Country.HomePage.SplashSection.Countdown
                    .HoursText
                )
              : 'Hours',
          MinutesText:
            !props.loading &&
            props.data &&
            props.data.fetch.Country.HomePage &&
            props.data.fetch.Country.HomePage.SplashSection &&
            props.data.fetch.Country.HomePage.SplashSection.Countdown &&
            props.data.fetch.Country.HomePage.SplashSection.Countdown
              .MinutesText
              ? props.getText(
                  props.data.fetch.Country.HomePage.SplashSection.Countdown
                    .MinutesText
                )
              : 'Minutes',
          SecondsText:
            !props.loading &&
            props.data &&
            props.data.fetch.Country.HomePage &&
            props.data.fetch.Country.HomePage.SplashSection &&
            props.data.fetch.Country.HomePage.SplashSection.Countdown &&
            props.data.fetch.Country.HomePage.SplashSection.Countdown
              .SecondsText
              ? props.getText(
                  props.data.fetch.Country.HomePage.SplashSection.Countdown
                    .SecondsText
                )
              : 'Seconds',
          SplashText:
            !props.loading &&
            props.data &&
            props.data.fetch.Country.HomePage &&
            props.data.fetch.Country.HomePage.SplashSection &&
            props.data.fetch.Country.HomePage.SplashSection.SplashText
              ? props.getText(
                  props.data.fetch.Country.HomePage.SplashSection.SplashText
                )
              : 'Represent your country'
        }}
        date={
          !props.loading &&
          props.data &&
          props.data.fetch.Country.HomePage.SplashSection &&
          props.data.fetch.Country.HomePage.SplashSection.Countdown &&
          props.data.fetch.Country.HomePage.SplashSection.Countdown
            .CountdownDate
            ? new Date(
                parseInt(
                  props.data.fetch.Country.HomePage.SplashSection.Countdown
                    .CountdownDate,
                  10
                ) * 1000
              )
            : new Date()
        }
        src={
          props.loading
            ? ''
            : props.data
            ? props.data.fetch.Country.HomePage &&
              props.data.fetch.Country.HomePage.SplashSection &&
              props.data.fetch.Country.HomePage.SplashSection.HomeSplashImage
              ? props.data.fetch.Country.HomePage.SplashSection.HomeSplashImage
                  .src
              : ''
            : ''
        }
        loading={props.loading}
      />
      <ExplainContainer
        style={{
          backgroundColor: explainBackground,
          color: explainTextColor
        }}
      >
        <Explain
          loading={props.loading}
          items={
            !props.loading && props.data
              ? [
                  {
                    count: props.getText(
                      props.data.fetch.Country.HomePage &&
                        props.data.fetch.Country.HomePage.Numbers &&
                        props.data.fetch.Country.HomePage.Numbers
                          .VariableText &&
                        props.data.fetch.Country.HomePage.Numbers.VariableText
                          .CompetingCountriesCount
                        ? props.data.fetch.Country.HomePage.Numbers.VariableText
                            .CompetingCountriesCount
                        : ''
                    ),
                    text: props.getText(
                      props.data.fetch.Country.HomePage &&
                        props.data.fetch.Country.HomePage.Numbers &&
                        props.data.fetch.Country.HomePage.Numbers
                          .VariableLabels &&
                        props.data.fetch.Country.HomePage.Numbers.VariableLabels
                          .CompetingCountriesText
                        ? props.data.fetch.Country.HomePage.Numbers
                            .VariableLabels.CompetingCountriesText
                        : ''
                    )
                  },
                  {
                    count: props.getText(
                      props.data.fetch.Country.HomePage &&
                        props.data.fetch.Country.HomePage.Numbers &&
                        props.data.fetch.Country.HomePage.Numbers
                          .VariableText &&
                        props.data.fetch.Country.HomePage.Numbers.VariableText
                          .QualifyingEventsCount
                        ? props.data.fetch.Country.HomePage.Numbers.VariableText
                            .QualifyingEventsCount
                        : ''
                    ),
                    text: props.getText(
                      props.data.fetch.Country.HomePage &&
                        props.data.fetch.Country.HomePage.Numbers &&
                        props.data.fetch.Country.HomePage.Numbers
                          .VariableLabels &&
                        props.data.fetch.Country.HomePage.Numbers.VariableLabels
                          .QualifyingEventsText
                        ? props.data.fetch.Country.HomePage.Numbers
                            .VariableLabels.QualifyingEventsText
                        : ''
                    )
                  },
                  {
                    count: props.getText(
                      props.data.fetch.Country.HomePage &&
                        props.data.fetch.Country.HomePage.Numbers &&
                        props.data.fetch.Country.HomePage.Numbers
                          .VariableText &&
                        props.data.fetch.Country.HomePage.Numbers.VariableText
                          .PlayersParticipatingCount
                        ? props.data.fetch.Country.HomePage.Numbers.VariableText
                            .PlayersParticipatingCount
                        : ''
                    ),
                    text: props.getText(
                      props.data.fetch.Country.HomePage &&
                        props.data.fetch.Country.HomePage.Numbers &&
                        props.data.fetch.Country.HomePage.Numbers
                          .VariableLabels &&
                        props.data.fetch.Country.HomePage.Numbers.VariableLabels
                          .PlayersParticipatingText
                        ? props.data.fetch.Country.HomePage.Numbers
                            .VariableLabels.PlayersParticipatingText
                        : ''
                    )
                  }
                ]
              : undefined
          }
        />
      </ExplainContainer>
      {/* Hide Banners section if there are no banners */}
      {!props.loading &&
        props.data &&
        props.data.fetch.Country.HomePage.Banners &&
        props.data.fetch.Country.HomePage.Banners.length && (
          <GallerySection
            loading={props.loading}
            width="100%"
            overflow="hidden"
            settings={{ autoplay: true, autoplaySpeed: 5000 }}
            images={
              props.data && !props.loading
                ? props.data.fetch.Country.HomePage.Banners.map(item => ({
                    buttonLink: item.ButtonLink || '',
                    buttonText: props.getText(item.ButtonText),
                    name: props.getText(item.Name),
                    src: item.BannerImage ? item.BannerImage.src : '',
                    subtitle: props.getText(item.Subtitle)
                  }))
                : []
            }
          />
        )}
      {(props.loading ||
        (props.data &&
          props.data.fetch.Country.HomePage.WorldFinalsConfig &&
          props.data.fetch.Country.HomePage.WorldFinalsConfig.Description)) && (
        <StyledDescription
          link={
            !props.loading &&
            props.data &&
            props.data.fetch.Country.HomePage.WorldFinalsConfig &&
            props.data.fetch.Country.HomePage.WorldFinalsConfig.ButtonLink
              ? props.data.fetch.Country.HomePage.WorldFinalsConfig.ButtonLink
              : null
          }
          background={
            !props.loading &&
            props.data &&
            props.data.fetch.Country.HomePage.WorldFinalsConfig &&
            props.data.fetch.Country.HomePage.WorldFinalsConfig.DescriptionImage
              ? `url(${
                  props.data.fetch.Country.HomePage.WorldFinalsConfig
                    .DescriptionImage.src
                })`
              : 'black'
          }
          loading={props.loading}
          text={
            !props.loading &&
            props.data &&
            props.data.fetch.Country.HomePage.WorldFinalsConfig
              ? props.data.fetch.Country.HomePage.WorldFinalsConfig.Description
              : ''
          }
          buttonText={
            !props.loading &&
            props.data &&
            props.data.fetch.Country.HomePage.WorldFinalsConfig &&
            props.data.fetch.Country.HomePage.WorldFinalsConfig
              .DescriptionButtonText
              ? props.getText(
                  props.data.fetch.Country.HomePage.WorldFinalsConfig
                    .DescriptionButtonText
                )
              : 'View our rules'
          }
        />
      )}
      {!(
        !props.loading &&
        props.data &&
        !props.data.fetch.Country.HomePage.HomeVideo
      ) && (
        <Video
          background={videoBackground}
          loading={props.loading}
          source={
            !props.loading &&
            props.data &&
            props.data.fetch.Country.HomePage.HomeVideo &&
            props.data.fetch.Country.HomePage.HomeVideo.HomeVideo
              ? props.data.fetch.Country.HomePage.HomeVideo.HomeVideo
              : false
          }
        />
      )}
      {!props.loading &&
        props.data &&
        props.data.fetch.Country.HomePage &&
        props.data.fetch.Country.HomePage.NewsSection &&
        props.data.fetch.Country.HomePage.NewsSection.ShowNews === 'yes' && (
          <News
            background={newsBackground}
            color={newsColor}
            loading={props.loading}
            title={
              !props.loading &&
              props.data &&
              props.data.fetch.Country.HomePage.NewsSection
                ? props.getText(
                    props.data.fetch.Country.HomePage.NewsSection.LatestNews
                  )
                : null
            }
            readMoreText={
              !props.loading &&
              props.data &&
              props.data.fetch.Country.HomePage.NewsSection &&
              props.data.fetch.Country.HomePage.NewsSection.ReadMore
                ? props.getText(
                    props.data.fetch.Country.HomePage.NewsSection.ReadMore
                  )
                : 'read more'
            }
            globalFeatured={
              !props.loading &&
              props.data &&
              props.data.fetch.Global.HomePage.NewsSection &&
              props.data.fetch.Global.HomePage.NewsSection.FeaturedNews
                ? mapItem(
                    props.data.fetch.Global.HomePage.NewsSection.FeaturedNews
                  )
                : undefined
            }
            globalNews={
              !props.loading &&
              props.data &&
              props.data.fetch.Global.HomePage.NewsSection &&
              props.data.fetch.Global.HomePage.NewsSection.News
                ? props.data.fetch.Global.HomePage.NewsSection.News.map(mapItem)
                : undefined
            }
            localFeatured={
              !props.loading &&
              props.data &&
              props.data.fetch.Country.HomePage.NewsSection &&
              props.data.fetch.Country.HomePage.NewsSection.FeaturedNews
                ? mapItem(
                    props.data.fetch.Country.HomePage.NewsSection.FeaturedNews
                  )
                : undefined
            }
            localNews={
              !props.loading &&
              props.data &&
              props.data.fetch.Country.HomePage.NewsSection &&
              props.data.fetch.Country.HomePage.NewsSection.News
                ? props.data.fetch.Country.HomePage.NewsSection.News.map(
                    mapItem
                  )
                : undefined
            }
          />
        )}

      {!props.loading &&
        props.data &&
        props.data.fetch.Country.HomePage.SponsorLogos &&
        props.data.fetch.Country.HomePage.SponsorLogos.ShowSponsors ===
          'yes' && (
          <Sponsors
            background={sponsorsBackground}
            loading={props.loading}
            images={
              !props.loading && props.data
                ? props.data.fetch.Country.HomePage.SponsorLogos.SponsorImages.map(
                    item => item.SponsorImage.src
                  )
                : undefined
            }
          />
        )}
      {!props.loading &&
        props.data &&
        props.data.fetch.Country.HomePage.SocialMedia && (
          <Social
            result={props.data.fetch.Country.HomePage.SocialMedia}
            background={socialBackground}
          />
        )}
    </div>
  );
};

const ExplainContainer = styled.div`
  padding: 30px;
`;

const StyledDescription = styled(Description)<{
  background: string;
}>`
  color: white;
  margin-top: -4px;
  background: ${p => p.background};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const GallerySection = styled(Gallery)`
  button {
    color: #000;
    &:hover {
      color: #fff;
    }
  }
`;

const Video = styled(HomeVideo)<{ background: string }>`
  background: ${p => p.background};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
`;

const News = styled(NewsSection)<{
  background: string;
  color: string;
}>`
  color: #333;
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.09) 100%
  );
`;

const Sponsors = styled(SponsorSection)<{
  background: string;
}>`
  background: ${p => p.background};
`;

const Social = styled(SocialSection)<{
  background: string;
}>`
  background: ${p => p.background};
`;

export default withLanguageState(withCountry(withHomePageQuery(HomePage)));



// WEBPACK FOOTER //
// ./src/pages/HomePage/HomePage.tsx